import type { Diagnostic } from "@/types";

export const getGpsData = (diagnostic?: Diagnostic) => {
  if (!diagnostic?.gps_position) {
    return;
  }
  const [latitude, longitude] = diagnostic.gps_position?.split(",") || [];
  if (!latitude || !longitude) {
    return;
  }
  const lat = parseFloat(latitude?.trim());
  const long = parseFloat(longitude?.trim());
  if (isNaN(lat) || isNaN(long)) {
    return;
  }

  return {
    latitude,
    longitude,
  };
};

export const googleUrl = ({
  latitude,
  longitude,
}: {
  latitude: string;
  longitude: string;
}) =>
  `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
